export var ShowBenchmarkOption;
(function (ShowBenchmarkOption) {
    ShowBenchmarkOption["ALL"] = "all";
    ShowBenchmarkOption["NONE"] = "none";
    ShowBenchmarkOption["MODULE_DEFAULT"] = "module_default";
})(ShowBenchmarkOption || (ShowBenchmarkOption = {}));
